import {
  ApplicationConfig,
  CSP_NONCE,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';

import { routes } from './app.routes';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideHttpModule, provideMaterialUIDefaultOptions } from '@core/providers';
import { provideTranslate } from '@translate';
import { recaptchaConfigInitialize } from '@core/services';
import { provideAPIModule } from '@core/providers/api-provider';

/* eslint-disable  @typescript-eslint/no-explicit-any */
const nonce = (window as any)?.__CSP_NONCE__;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAPIModule(),
    provideHttpModule(),
    provideAppInitializer(recaptchaConfigInitialize),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideMaterialUIDefaultOptions(),
    provideEnvironmentNgxMask(),
    provideTranslate(),
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: CSP_NONCE, useValue: nonce },
  ],
};
